import React from 'react';

const ACTION_LABELS = {
  create_node: 'Create Node',
  update_node: 'Update Node',
  delete_node: 'Delete Node',
  create_synapse: 'Create Synapse',
  update_synapse: 'Update Synapse',
  delete_synapse: 'Delete Synapse',
  create_gate: 'Create Gate',
  update_gate: 'Update Gate',
  delete_gate: 'Delete Gate',
};

const ACTION_ICONS = {
  create_node: '+',
  update_node: '~',
  delete_node: '×',
  create_synapse: '+',
  update_synapse: '~',
  delete_synapse: '×',
  create_gate: '+',
  update_gate: '~',
  delete_gate: '×',
};

function getActionCategory(action) {
  if (action.startsWith('create')) return 'create';
  if (action.startsWith('update')) return 'update';
  if (action.startsWith('delete')) return 'delete';
  return 'update';
}

function renderProposedDetails(proposal) {
  const { action, proposed, before } = proposal;
  const details = [];

  if (action.includes('node')) {
    if (proposed?.node_name) details.push(['Name', proposed.node_name]);
    if (proposed?.node_description) details.push(['Description', proposed.node_description.slice(0, 200)]);
    if (proposed?.node_type) details.push(['Type', proposed.node_type]);
    if (before?.node_name && proposed?.node_name && before.node_name !== proposed.node_name) {
      details.push(['Was', before.node_name]);
    }
  }

  if (action.includes('synapse')) {
    if (proposed?.source_name) details.push(['From', proposed.source_name]);
    if (proposed?.target_name) details.push(['To', proposed.target_name]);
    if (proposed?.edge_name) details.push(['Edge', proposed.edge_name]);
    if (proposed?.weight != null) details.push(['Weight', String(proposed.weight)]);
    if (before?.weight != null && proposed?.weight != null && before.weight !== proposed.weight) {
      details.push(['Was weight', String(before.weight)]);
    }
  }

  if (action.includes('gate')) {
    if (proposed?.gate_name) details.push(['Name', proposed.gate_name]);
    if (proposed?.gate_type) details.push(['Type', proposed.gate_type]);
    if (proposed?.threshold != null) details.push(['Threshold', String(proposed.threshold)]);
    if (proposed?.rule_expression) details.push(['Rule', proposed.rule_expression]);
  }

  if (action.startsWith('delete') && before) {
    const name = before.node_name || before.gate_name || before.edge_name || '';
    if (name) details.push(['Deleting', name]);
  }

  return details;
}

function ChangePreviewCard({ proposal, onAccept, onReject, accepted }) {
  const { action } = proposal;
  const category = getActionCategory(action);
  const details = renderProposedDetails(proposal);

  return (
    <div className="change-proposal-card">
      <div className={`change-proposal-card__header change-proposal-card__header--${category}`}>
        <span>{ACTION_ICONS[action] || '?'}</span>
        <span>{ACTION_LABELS[action] || action}</span>
      </div>

      {details.length > 0 && (
        <div className="change-proposal-card__body">
          <dl style={{ margin: 0 }}>
            {details.map(([label, value], i) => (
              <React.Fragment key={i}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </React.Fragment>
            ))}
          </dl>
        </div>
      )}

      {onAccept && onReject && !accepted && (
        <div className="change-proposal-card__actions">
          <button className="btn-accept" onClick={onAccept}>Accept</button>
          <button className="btn-reject" onClick={onReject}>Reject</button>
        </div>
      )}
      {accepted && (
        <div className="change-proposal-card__actions">
          <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>Accepted</span>
        </div>
      )}
    </div>
  );
}

export default ChangePreviewCard;
